import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import en from './lang/en.json'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    'en': en
  },
  silentTranslationWarn: true
})

const loadedLanguages = ['en-US']

function setI18nLanguage (langLocale) {
  let lang = langLocale.split('-')[0]
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

i18n.setLanguage = function setLanguage (langLocale) {
  let lang = langLocale.split('-')[0]
  if (i18n.locale !== lang) {
    Vue.prototype.$moment.updateLocale(lang, { week: { dow: 0 } });
    if (loadedLanguages.indexOf(lang) < 0) {
      return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

export default i18n
